/* eslint-disable import/no-default-export */
import { Test, Variation } from './types';
import { trackExperiment } from '@trello/analytics';
export default class CollapsedTest {
  test: Test;
  selectedVariation: Variation | undefined;
  identifier: string;

  constructor(
    test: Test,
    selectedVariation: Variation | undefined,
    identifier: string,
  ) {
    this.test = test;
    this.selectedVariation = selectedVariation;
    this.identifier = identifier;
  }
  track() {
    return trackExperiment(
      this.test.name + this.test.experimentVersion,
      this.selectedVariation ? this.selectedVariation.name : undefined,
      this.identifier,
    );
  }
  get inExperiment() {
    return !!this.selectedVariation;
  }
  get(name: string) {
    if (name === 'variation') {
      if (this.selectedVariation && this.selectedVariation.name) {
        return this.selectedVariation.name;
      } else {
        return 'control';
      }
    } else if (
      this.selectedVariation &&
      this.selectedVariation.values &&
      Object.prototype.hasOwnProperty.call(this.selectedVariation.values, name)
    ) {
      return this.selectedVariation.values[name];
    } else if (
      this.test.defaults &&
      Object.prototype.hasOwnProperty.call(this.test.defaults, name)
    ) {
      return this.test.defaults[name];
    } else {
      return null;
    }
  }
}
